module.exports = __webpack_public_path__ + "img/43_31.e7398410.png";